import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ResponsiveContext } from '../contexts/ResponsiveContext';
import { useAuth } from '../hooks/useAuth';
import { findAllCarts } from '../service/ProductsService';
import Message from './LoadingError/Error';
// import LogoTienda from '../assets/img/logo-tienda.png';
import LogoTienda from '../assets/img/logo-tienda.webp';
// import Logo from '../assets/img/logo.png';
import Logo from '../assets/img/logo.webp';

const Header = ({ filterProducts, searcherDisabled, shopLink }) => {
  const [cart, setCart] = useState();
  const [error, setError] = useState();

  const { user, logout } = useAuth();

  const { is350, is775 } = useContext(ResponsiveContext);

  const navigate = useNavigate();

  const logoutHandler = () => {
    logout();
  };

  useEffect(() => {
    if (user) {
      findAllCarts()
        .then((carts) => setCart(carts))
        .catch((error) => setError(error.response.data.message));
    }
  }, [user]);

  return (
    <div>
      {/* Top Header */}
      {error && <Message variant='alert-danger'>{error}</Message>}
      <div className='Announcement '>
        <div className='container'>
          <div className='row'>
            <div className='col-md-6 d-flex align-items-center display-none'>
              <p>
                <b>+ 34 914 04 51 09</b>
              </p>
              <p>
                <b>deportessporting@gmail.com</b>
              </p>
            </div>
            <div
              className={`col-12 col-lg-6 ${
                is350 ? 'justify-content-center' : 'justify-content-around'
              } justify-content-lg-end d-flex align-items-center`}
            >
              <a href='https://www.facebook.com/deportessporting'>
                <i className='fab fa-facebook-f'></i>
              </a>
              <a href='https://www.instagram.com/deportessporting'>
                <i className='fab fa-instagram'></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* Header */}
      <div className='header'>
        <div className='container'>
          {/* MOBILE HEADER */}
          {!is775 && (
            <div className='mobile-header'>
              <div className='container '>
                <div className='row d-flex justify-content-between'>
                  <div className='col-4 d-flex align-items-center'>
                    <img
                      alt='logo'
                      src={Logo}
                      style={{
                        width: '100%',
                        maxWidth: '120px',
                        height: 'auto',
                        cursor: 'pointer',
                      }}
                      onClick={() => navigate('/')}
                    />
                  </div>
                  {shopLink && (
                    <div className='col-4 d-flex justify-content-center align-items-center'>
                      <img
                        alt='logo'
                        src={LogoTienda}
                        style={{
                          width: '80%',
                          maxWidth: '120px',
                          height: 'auto',
                          cursor: 'pointer',
                        }}
                        onClick={() => navigate('/shop')}
                      />
                    </div>
                  )}
                  <div className='col-4 d-flex align-items-center justify-content-end Login-Register'>
                    {user ? (
                      <div className='btn-group'>
                        <button
                          type='button'
                          className='name-button dropdown-toggle'
                          data-toggle='dropdown'
                          aria-haspopup='true'
                          aria-expanded='false'
                        >
                          <i className='fas fa-user'></i>
                        </button>
                        <div className='dropdown-menu'>
                          <Link className='dropdown-item' to='/profile'>
                            Profile
                          </Link>

                          <Link
                            className='dropdown-item'
                            to='#'
                            onClick={logoutHandler}
                          >
                            Logout
                          </Link>
                        </div>
                      </div>
                    ) : (
                      <div className='btn-group'>
                        <button
                          type='button'
                          className='name-button dropdown-toggle'
                          data-toggle='dropdown'
                          aria-haspopup='true'
                          aria-expanded='false'
                        >
                          <i className='fas fa-user'></i>
                        </button>
                        <div className='dropdown-menu'>
                          <Link className='dropdown-item' to='/login'>
                            Acceder
                          </Link>

                          <Link className='dropdown-item' to='/register'>
                            Registrarse
                          </Link>
                        </div>
                      </div>
                    )}
                    {user && (
                      <Link to='/cart' className='cart-mobile-icon'>
                        <i className='fas fa-shopping-bag'></i>
                        <span className='badge'>{cart?.length}</span>
                      </Link>
                    )}
                  </div>
                  <div className='col-12 d-flex align-items-center'>
                    {!searcherDisabled && (
                      <form className='input-group'>
                        <input
                          type='search'
                          className='form-control rounded search'
                          placeholder='Buscar'
                          onChange={(e) => filterProducts(e.target.value)}
                        />
                      </form>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* PC HEADER */}
          {is775 && (
            <div className='pc-header'>
              <div className='row'>
                <div className='col-md-3 col-4 d-flex align-items-center'>
                  <img
                    alt='logo'
                    src={Logo}
                    style={{
                      width: '100%',
                      maxWidth: '120px',
                      height: 'auto',
                      cursor: 'pointer',
                    }}
                    onClick={() => navigate('/')}
                  />
                </div>
                <div className='col-md-6 col-8 d-flex align-items-center'>
                  {!searcherDisabled && (
                    <form className='input-group'>
                      <input
                        type='search'
                        className='form-control rounded search'
                        placeholder='Buscar'
                        onChange={(e) => filterProducts(e.target.value)}
                      />
                    </form>
                  )}
                  {shopLink && (
                    <div
                      className='d-flex justify-content-center align-items-center'
                      style={{ width: '100%' }}
                    >
                      <img
                        alt='logo'
                        src={LogoTienda}
                        style={{
                          width: '80%',
                          maxWidth: '120px',
                          height: 'auto',
                          cursor: 'pointer',
                        }}
                        onClick={() => navigate('/shop')}
                      />
                    </div>
                  )}
                </div>
                <div className='col-md-3 d-flex align-items-center justify-content-end Login-Register'>
                  {user ? (
                    <div className='btn-group'>
                      <button
                        type='button'
                        className='name-button dropdown-toggle'
                        data-toggle='dropdown'
                        aria-haspopup='true'
                        aria-expanded='false'
                      >
                        Hola, {user.name}
                      </button>
                      <div className='dropdown-menu'>
                        <Link className='dropdown-item' to='/profile'>
                          Perfil
                        </Link>

                        <Link
                          className='dropdown-item'
                          to='/'
                          onClick={logoutHandler}
                        >
                          Salir
                        </Link>
                      </div>
                    </div>
                  ) : (
                    <>
                      <Link to='/register'>Registrarse</Link>
                      <Link to='/login'>Acceder</Link>
                    </>
                  )}
                  {user && (
                    <Link to='/cart'>
                      <i
                        className='fas fa-shopping-bag'
                        style={{ fontSize: '25px' }}
                      ></i>
                      <span className='badge'>{cart?.length}</span>
                    </Link>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
